<template>
	<div class="shop">
		<back-to></back-to>
		<section class="integral_top">
			<img class="integral_top-img"
				:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/integral-04.png?v='+Math.random()" alt="">
			<div class="integral_top-con">
				<label class="integral_top-cont">
					<p>{{user.score}}</p>
					<font>积分</font>
				</label>
				<label class="integral_top-conr" for="" @click="$router.push({ path: '/exchange'})">
					<p>兑换记录</p>
					<img class="integral_top-contr"
						:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/integral-03.png?v='+Math.random()"
						alt="">
				</label>
			</div>
		</section>
		<section class="integral_center">
			<h2>好物兑换</h2>
		</section>
		<!-- 列表 -->
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
			<section class="orderList-list">
				<div class="orderList-item" v-for="(item,index) in list" :key="index"
					@click="$router.push({path: '/shopDetail',query:{id:item.id}})">
					<span class="item-i">
						<img :src="item.images[0]" alt="">
					</span>
					<span class="item-t">{{item.name}}</span>
					<span class="item-s">{{item.score}}积分</span>
				</div>
			</section>

		</van-list>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'shop',
		components: {
			BackTo
		},
		data() {
			return {
				user: "",
				loading: false,
				finished: false,
				pageIndex: 1,
				list: []
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getMes()
			this.getList()
		},
		methods: {
			getMes() {
				var jsonData = {
					"ptId": this.$organizationId,
					"webUserId": this.userInfo.userId,
					"userName": this.userInfo.wxNick,
					"phone": this.userInfo.phone,
					"wxOpenId": "",
					"wxFace": this.userInfo.wxFace
				}
				this.$post(
					this.$activity + '/Score/ScoreUserGetById', jsonData
				).then(res => {
					this.user = res
				})
			},
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.pageIndex = this.pageIndex + 1
					this.getList()
				}, 500);
			},
			getList() {
				let param = {
					"ptId": this.$organizationId,
					"pageIndex": this.pageIndex,
					"pageSize": 10
				}
				this.$post(
					this.$activity + '/Score/ScoreProductGetAll', param
				).then(res => {
					this.list = this.list.concat(res.items)
					if (res.items.length < 10) {
						this.finished = true;
					}
				})
			},
		}
	}
</script>

<style scoped>
	.integral_top {
		width: 100%;
		padding: 40px;
		box-sizing: border-box;
		position: relative;
	}

	.integral_top-img {
		width: 100%;
		height: 140px;
	}

	.integral_top-con {
		padding: 0 60px;
		box-sizing: border-box;
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: 220px;
	}

	.integral_top-conr {
		display: flex;
		align-items: baseline;
	}

	.integral_top-cont {
		display: flex;
		align-items: baseline;
		font-size: 24px;
		color: #fff;
	}

	.integral_top-cont p {
		font-size: 60px;
		font-weight: bold;
		margin-right: 14px;
	}

	.integral_top-contr {
		width: 10px;
	}

	.integral_top-conr p {
		color: #894400;
		font-size: 24px;
		margin-right: 10px;
	}

	.integral_top-conr label {
		display: flex;
		align-items: center;
	}

	.integral_center {
		width: 100%;
		padding: 0 40px 20px 40px;
		box-sizing: border-box;
	}

	.integral_center h2 {
		font-size: 36px;
		color: #333;
	}

	.orderList-list {
		display: flex;
		box-sizing: border-box;
		width: 100%;
		padding: 0 20px;
		flex-wrap: wrap;
	}

	.orderList-item {
		margin-top: 40px;
		width: 200px;
		margin-right: 55px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.orderList-item:nth-of-type(3n) {
		margin-right: 0;
	}

	.item-i {
		height: 200px;
		width: 200px;
		overflow: hidden;
		border-radius: 20px;
	}

	.item-i img {
		height: 200px;
		width: 200px;
	}

	.item-t {
		font-size: 24px;
		margin-top: 16px;
		color: #333;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
	}

	.item-s {
		font-size: 20px;
		color: #ff8a00;
		margin-top: 16px;
	}
</style>
